// Authentication
export { AuthProvider, useAuth } from './use-auth';
export { useAuthStatus, type AuthStatus } from './use-auth-status';

// Theme & Colors
export { useColorScheme } from './use-color-scheme';
export { useUnifiedColorScheme } from './use-unified-color-scheme';

// Utilities
export { useDebouncedValue } from './use-debounced-value';
export { useUserLocation, type LocationStatus, type UserLocation } from './use-user-location';

// Notifications (platform-specific - no barrel export needed)
// use-notifications.native.ts and use-notifications.web.ts

// Profile
export {
  PROFILE_QUERY_KEYS, useCachedProfile, useCurrentUserProfile, useInvalidateProfile, usePrefetchProfile, useUpdateProfile,
  useUploadProfilePhoto, useUserProfile,
  useUserProfileByUsername, type PhotoUploadResponse,
  type UpdateProfileData
} from './use-profile';

